import { PermissionsCategory } from "src/app/auth/permissions";

@PermissionsCategory("AreaOfConcernPermissions")
export class AreaOfConcernPermissions {
    static readonly None = 0;
    static readonly View = 1;
    static readonly Edit = 2;
    static readonly Delete = 4;
    static readonly SeeAll = 8;
    // 16 is skipped deliberately — see AreaOfConcernPermissions.cs.
    static readonly Export = 32;
}
